import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace GuestProfileModels {
/** 
 * GuestProfileStatusEnumSchema 
 * @type { enum }
 */
export const GuestProfileStatusEnumSchema = z.enum(["no_data", "enqueued", "processing", "processing_failed", "completed"]);
export type GuestProfileStatusEnum = z.infer<typeof GuestProfileStatusEnumSchema>;
export const GuestProfileStatusEnum = GuestProfileStatusEnumSchema.enum;

/** 
 * GuestProfileManualSubmitRequestDtoSchema 
 * @type { object }
 * @property { CommonModels.ProfileV2DataUpdateDto } dataV02  
 * @property { string } name Optional guest profile name 
 * @property { string } jobPosition  
 */
export const GuestProfileManualSubmitRequestDtoSchema = z.object({ dataV02: CommonModels.ProfileV2DataUpdateDtoSchema, name: z.string().nullish(), jobPosition: z.string().nullish() });
export type GuestProfileManualSubmitRequestDto = z.infer<typeof GuestProfileManualSubmitRequestDtoSchema>;


/** 
 * GuestProfileResponseDtoSchema 
 * @type { object }
 * @property { string } id  
 * @property { string } name  
 * @property { string } status  
 * @property { string } jobPosition  
 * @property { string } jobTitle  
 * @property { CommonModels.WorthNumbersDto } worthNumbers  
 * @property { CommonModels.ProfileV2DataDto } dataV02  
 * @property { CommonModels.ProfileBlsSkillIndustryResponseDto } skillIndustry  
 */
export const GuestProfileResponseDtoSchema = z.object({ id: z.string().nullish(), name: z.string().nullish(), status: GuestProfileStatusEnumSchema, jobPosition: z.string().nullish(), jobTitle: z.string().nullish(), worthNumbers: CommonModels.WorthNumbersDtoSchema.nullish(), dataV02: CommonModels.ProfileV2DataDtoSchema.nullish(), skillIndustry: CommonModels.ProfileBlsSkillIndustryResponseDtoSchema.nullish() });
export type GuestProfileResponseDto = z.infer<typeof GuestProfileResponseDtoSchema>;


/** 
 * GuestProfilePresignedUrlRequestDtoSchema 
 * @type { object }
 * @property { string } fileName Example: `resume.pdf` 
 * @property { number } fileSize Minimum: `1`. Example: `1024` 
 * @property { string } mimeType Example: `application/pdf` 
 */
export const GuestProfilePresignedUrlRequestDtoSchema = z.object({ fileName: z.string(), fileSize: z.number().gte(1), mimeType: z.string().nullish() });
export type GuestProfilePresignedUrlRequestDto = z.infer<typeof GuestProfilePresignedUrlRequestDtoSchema>;


/** 
 * GuestProfileResumeSubmitRequestDtoSchema 
 * @type { object }
 * @property { string } fileId Media file id returned from presigned-url request 
 * @property { string } name Optional guest profile name 
 */
export const GuestProfileResumeSubmitRequestDtoSchema = z.object({ fileId: z.string(), name: z.string().nullish() });
export type GuestProfileResumeSubmitRequestDto = z.infer<typeof GuestProfileResumeSubmitRequestDtoSchema>;


/** 
 * GuestProfileShareRequestDtoSchema 
 * @type { object }
 * @property { string } email Example: `friend@example.com` 
 */
export const GuestProfileShareRequestDtoSchema = z.object({ email: z.email() });
export type GuestProfileShareRequestDto = z.infer<typeof GuestProfileShareRequestDtoSchema>;


/** 
 * GuestProfileEditRequestDtoSchema 
 * @type { object }
 * @property { string } jobPosition  
 * @property { string } city  
 * @property { string } state Max Length: `2` 
 * @property { string } country Min Length: `2`. Max Length: `2` 
 */
export const GuestProfileEditRequestDtoSchema = z.object({ jobPosition: z.string(), city: z.string(), state: z.string().max(2).nullable(), country: z.string().min(2).max(2) });
export type GuestProfileEditRequestDto = z.infer<typeof GuestProfileEditRequestDtoSchema>;


}
